import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import PageSectionCards, {
    PageSectionCardsProps,
} from 'components/page/sections/page-section-cards';

export const SnoozeModeBlockFiveContainer: FunctionComponent = () => {
    const props = {
        title: features.snoozeMode.lxSnoozeModeFiveBlockTitle,
        items: [
            {
                imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/snooze-mode/snooze-mode-love-snooze-mode-1.svg`,
                title: features.snoozeMode.lxSnoozeModeFiveBlockSubtitleOne,
                text: features.snoozeMode.lxSnoozeModeFiveBlockBodyTextOne,
                titleTag: 'h3',
            },
            {
                imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/snooze-mode/snooze-mode-love-snooze-mode-2.svg`,
                title: features.snoozeMode.lxSnoozeModeFiveBlockSubtitleTwo,
                text: features.snoozeMode.lxSnoozeModeFiveBlockBodyTextTwo,
                titleTag: 'h3',
            },
            {
                imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/snooze-mode/snooze-mode-love-snooze-mode-3.svg`,
                title: features.snoozeMode.lxSnoozeModeFiveBlockSubtitleThree,
                text: features.snoozeMode.lxSnoozeModeFiveBlockBodyTextThree,
                titleTag: 'h3',
            },
        ] as PageSectionCardsProps['cards'],
    };

    return <PageSectionCards title={props.title} cards={props.items} color="white" />;
};
